module.exports = __webpack_public_path__ + "static/media/trade.291f056c.svg";